import { Component, OnDestroy, OnInit } from '@angular/core';
import { StorageService, StorageType } from 'gast-common-ng';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CertificateService } from '../shared/services/certificate.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { VerificationBestOfCertificateDto } from '../shared/dto/verification-best-of-certificate-testdaf.dto';

export class TdnModel {
  displayText: string;
  value: string;
}

export class ScoreModel {
  displayText: string;
  value: string;
}

@Component({
  selector: 'app-verification-best-of-certificate-testdaf',
  templateUrl: './verification-best-of-certificate-testdaf.component.html',
  styleUrls: ['./verification-best-of-certificate-testdaf.component.css']
})
export class VerificationBestOfCertificateTestdafComponent implements OnInit, OnDestroy {
  isSubmitted = false;
  hasError = false;
  isLoading = false;

  tdnValues = [];
  scores = [];

  // inputs
  participantNumber: number;
  participantName: string;
  dateOfBirth: Date;
  readingTdn: string;
  listeningTdn: string;
  writingTdn: string;
  speakingTdn: string;
  readingScore: string;
  listeningScore: string;
  writingScore: string;
  speakingScore: string;

  token: string;

  subscription = new Subscription();

  result: VerificationBestOfCertificateDto;

  constructor(
    private localeService: BsLocaleService,
    private certificationService: CertificateService,
    private spinnerService: NgxSpinnerService,
    private storageService: StorageService,
    private route: ActivatedRoute) {
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    // init datepicker locale
    this.localeService.use('de');

    this.generateTdnValues();
    this.generateScores();
    this.restoreInputs();

    this.subscription = this.route.queryParams.subscribe(params => {
      this.token = params.token;
      if (this.token) {
        this.certificationService.getTestdafBestOfCertificateVerificationByQrCode(this.token);
        this.spinnerService.show();
        this.isLoading = true;
      }
    });

    this.subscription.add(this.certificationService.resultTestdafBestofCertificateByQrCodeLoaded.subscribe(result => {
      if (result) {
        this.spinnerService.hide();
        this.result = result;
        this.setValuesFromDto(this.result);
        this.isSubmitted = true;
        this.isLoading = false;
      }
    }));

    this.subscription.add(this.certificationService.resultTestdafBestofCertificateByFormLoaded.subscribe(result => {
      this.spinnerService.hide();
      this.result = result;
      this.isSubmitted = true;
      this.isLoading = false;
    }));

    this.subscription.add(this.certificationService.verificationError.subscribe(() => {
      this.spinnerService.hide();
      this.result.verified = false;
      this.isLoading = false;
    }));
  }

  getBsConfig() {
    return {
      containerClass: 'theme-blue',
      dateInputFormat: 'DD.MM.YYYY'

    } as BsDatepickerConfig;
  }

  generateTdnValues() {
    const tdnValue1 = new TdnModel();
    tdnValue1.displayText = 'TDN u3';
    tdnValue1.value = 'u3';
    const tdnValue2 = new TdnModel();
    tdnValue2.displayText = 'TDN 3';
    tdnValue2.value = '3';
    const tdnValue3 = new TdnModel();
    tdnValue3.displayText = 'TDN 4';
    tdnValue3.value = '4';
    const tdnValue4 = new TdnModel();
    tdnValue4.displayText = 'TDN 5';
    tdnValue4.value = '5';
    this.tdnValues.push(tdnValue1);
    this.tdnValues.push(tdnValue2);
    this.tdnValues.push(tdnValue3);
    this.tdnValues.push(tdnValue4);
  }

  generateScores() {
    for (let i = 1; i < 21; i++) {
      const score = new ScoreModel();
      score.displayText = i + '/20';
      score.value = i.toString();
      this.scores.push(score);
    }
  }

  submit(): void {
    const dto = new VerificationBestOfCertificateDto();
    this.setValuesToDto(dto);
    this.saveInputs(dto);
    this.certificationService.getTestdafBestOfCertificateVerificationByForm(dto);
    this.isLoading = true;
    this.spinnerService.show();
  }

  private restoreInputs() {
    const dto = this.storageService.getItem('VERIFICATION_BEST_OF_CERTIFICATE_TESTDAF', StorageType.Session);
    this.setValuesFromDto(dto);
  }

  private saveInputs(dto: VerificationBestOfCertificateDto) {
    this.storageService.setItem('VERIFICATION_BEST_OF_CERTIFICATE_TESTDAF', dto, StorageType.Session);
    this.setValuesFromDto(dto);
  }

  private setValuesFromDto(dto: VerificationBestOfCertificateDto) {
    if (dto) {
      this.participantNumber = dto.participantNumber;
      this.participantName = dto.participantName;
      this.dateOfBirth = dto.dateOfBirth ? new Date(dto.dateOfBirth) : null;

      const formatScore = (value: number | null | undefined) =>
        value == null ? '' : value.toString();

      this.readingTdn = dto.leTdn;
      this.listeningTdn = dto.hoTdn;
      this.writingTdn = dto.scTdn;
      this.speakingTdn = dto.spTdn;

      this.readingScore = formatScore(dto.leScore);
      this.listeningScore = formatScore(dto.hoScore);
      this.writingScore = formatScore(dto.scScore);
      this.speakingScore = formatScore(dto.spScore);
    }
  }

  private setValuesToDto(dto: VerificationBestOfCertificateDto) {

    dto.participantNumber = this.participantNumber;
    dto.participantName = this.participantName;
    dto.dateOfBirth = this.dateOfBirth;

    dto.leTdn = this.readingTdn;
    dto.hoTdn = this.listeningTdn;
    dto.scTdn = this.writingTdn;
    dto.spTdn = this.speakingTdn;

    dto.leScore = Number(this.readingScore);
    dto.hoScore = Number(this.listeningScore);
    dto.scScore = Number(this.writingScore);
    dto.spScore = Number(this.speakingScore);

  }
}
